import { render, staticRenderFns } from "./YearlyIncomeReportsBox.vue?vue&type=template&id=fcac2c7a&scoped=true"
import script from "./YearlyIncomeReportsBox.vue?vue&type=script&lang=js"
export * from "./YearlyIncomeReportsBox.vue?vue&type=script&lang=js"
import style0 from "./YearlyIncomeReportsBox.vue?vue&type=style&index=0&id=fcac2c7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcac2c7a",
  null
  
)

export default component.exports